import React from "react";
import "./leftToRightFeatureContainer.css";
import { Link } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export default function LeftToRightFeatureContainer({
  smallHeading,
  mainHeading,
  desc,
  list,
  learnMoreLink,
  imgUrl,
}) {
  return (
    <div className="leftToRightFeatureContainer py-5">
      <div className="container">
        <div className="row">
          <div className="col-md-6 pe-md-5 pe-sm-0">
            <h4 className="leftToRightFeatureContainer-smallHeading my-3">
              {smallHeading}
            </h4>
            <h2 className="leftToRightFeatureContainer-mainHeading">
              {mainHeading}
            </h2>
            <p className="leftToRightFeatureContainer-desc">{desc}</p>
            <div className="leftToRightFeatureContainer-list">
              {list?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="leftToRightFeatureContainer-list-item"
                  >
                    <CheckIcon className="list-item-icon" />
                    <span>{item}</span>
                  </div>
                );
              })}
            </div>
            {learnMoreLink ? (
              <div className="leftToRightFeatureContainer-learnMore">
                <Link to={learnMoreLink}>
                  <button className="btn jump-hover">
                    <span>Learn More</span>
                    <ChevronRightIcon />
                  </button>
                </Link>
              </div>
            ) : null}
          </div>
          <div className="col-md-6 leftToRightFeatureContainer-img">
            <img src={imgUrl} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}
